export function castFixed(number, length = 3, floating = false) {
  const float = parseFloat(number)
  if (isNaN(float)) return number
  const remain = number.toString().replace(float, '')
  const fixed = float.toFixed(length)
  return floating ? parseFloat(fixed) : fixed + remain
}
